import getSpecialDay from "./getSpecialDay";
import createSpecialDay from "./createSpecialDay";
import updateSpecialDay from "./updateSpecialDay";
import deleteSpecialDay from "./deleteSpecialDay";

export { getSpecialDay, createSpecialDay, updateSpecialDay, deleteSpecialDay };

export default { getSpecialDay, createSpecialDay, updateSpecialDay, deleteSpecialDay };
